<template>
  <checkout-panel
    id="billing_address"
    index="2"
    title="Billing address"
    :editing="componentState.billing.editing"
    @handleEditing="handleEditing"
  >
    <template #main>
      <address-block
        v-if="selectedAddress"
        :address="selectedAddress"
      ></address-block>
      <h6 v-else>No billing address selected</h6>
    </template>
    <template #secondary>
      <error-component v-if="componentState.billing.error"></error-component>
      <loading-component
        v-else-if="componentState.billing.loading"
      ></loading-component>
      <checkout-change-address
        v-else-if="!addAddress"
        :selected-address-id="selectedAddressId"
        @toggleAddAddress="toggleAddAddress"
        @handleUpdate="handleUpdate"
      ></checkout-change-address>
      <div v-else style="padding: 2rem 3rem">
        <new-address-form
          :country="country"
          :states="regions"
          :user-id="userId"
          :cancellable="true"
          submit-text="Add address"
          success-response="addressCreated"
          error-response="addressError"
          @handleCancel="toggleAddAddress"
          @addressCreated="handleAddressCreated"
          @addressError="handleError"
        ></new-address-form>
      </div>
    </template>
  </checkout-panel>
</template>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";
import store from "../../../store/stores";
import AddressBlock from "./elements/AddressBlock.vue";
import CheckoutPanel from "../layout/CheckoutPanel.vue";
import CheckoutChangeAddress from "./address/CheckoutChangeAddress.vue";
import NewAddressForm from "./address/NewAddressForm.vue";
import LoadingComponent from "./elements/LoadingComponent.vue";
import ErrorComponent from "./elements/ErrorComponent.vue";

export default {
  store,
  components: {
    NewAddressForm,
    AddressBlock,
    CheckoutChangeAddress,
    CheckoutPanel,
    ErrorComponent,
    LoadingComponent,
  },
  data() {
    return {
      addAddress: false,
    };
  },
  computed: {
    selectedAddressId() {
      return this.$store.state.checkout.billingAddressId;
    },
    ...mapGetters({
      country: "checkout/country",
      regions: "checkout/regions",
      selectedAddress: "checkout/billingAddress",
      componentState: "checkout/componentState",
      userId: "checkout/userId",
    }),
  },
  methods: {
    handleEditing() {
      this.$store.commit("checkout/SET_EDITING", {
        componentName: "billing",
        boolVal: !this.componentState.billing.editing,
      });
    },
    handleUpdate(updateId) {
      this.$store.commit("checkout/SET_BILLING_ADDRESS_ID", updateId);
    },
    handleError(message) {
      swal.fire({
        title: "Uh oh..",
        type: "error",
        html: `<p style="font-size: small">We are unable update your address!</p>
            <p style="font-size: small">Please refresh the page and try again.</p>
          `,
      });
      this.$store.commit("checkout/SET_ERROR", {
        componentName: "shipping",
        message,
      });
    },
    handleAddressCreated(addressObj) {
      this.$store.commit("checkout/SET_NEW_ADDRESS", addressObj);
      this.$store.commit("checkout/SET_BILLING_ADDRESS_ID", addressObj.id);
      this.toggleAddAddress();
    },
    toggleAddAddress() {
      this.addAddress = !this.addAddress;
    },
  },
};
</script>
